class WoodShapesComponent extends HTMLElement {

  constructor() {
    super();
    this.shapeType = 'lumber-shape'
    
    this.shapeFiles = {      
      'lumber-shape': 'Wood/Lumber.json',
      'trus-joist-shape': 'engineered-lumber/trus-joist-shapes.json',
      'other-vendors-east-joist-shape': 'engineered-lumber/other-vendors-east-shapes.json',
      'other-vendors-west-joist-shape': 'engineered-lumber/other-vendors-west-shapes.json'
    }

    document.addEventListener('wood-shapes-selected', async () => this.onShapeCategorySelected(), true)
  }

  onShapeCategorySelected() {
    this.onShapeFileClick(this.shapeType)
  }

  resetButton(id) {
    document.getElementById(id).classList.add('btn-default')
    document.getElementById(id).classList.remove('btn-primary')
  }

  onShapeFileClick(id) {
    this.shapeType = id
    if(id === 'lumber-shape') {
      getWoodShapes(this.shapeFiles[id])
    } else {
      getEngineeredLumberShapes(this.shapeFiles[id])
    }
    // reset buttons
    this.resetButton('lumber-shape')
    this.resetButton('trus-joist-shape')
    this.resetButton('other-vendors-east-joist-shape')
    this.resetButton('other-vendors-west-joist-shape')
    document.getElementById(id).classList.add('btn-primary')
  }

  connectedCallback() {

    this.innerHTML = String.raw`
    <div>
      <button class="btn btn-default button-shadow" id='lumber-shape'>Lumber</button>
      <button class="btn btn-default button-shadow" id='trus-joist-shape'>TrusJoist</button>
      <button class="btn btn-default button-shadow" id='other-vendors-east-joist-shape'>Other Vendor LVL (east)</button>
      <button class="btn btn-default button-shadow" id='other-vendors-west-joist-shape'>Other Vendor LVL (west)</button>
    </div>

    <div class="text-left my-2">
      <div id="ply-selector-group" class="form-group">
        <label>Number of Plys</label>
        <select id="ply-selector" class="form-control" onchange="onPlySelectorChange()">
          <option>1</option>
          <option>2</option>
          <option>3</option>
          <option>4</option>
          <option>5</option>
        </select>
      </div>
    </div>

    <div id="flitch-input-form" class="row text-left my-2 d-none">
      <div  class="bg-primary-subtle modal-body-shadow col mx-2">
        <label style="margin:10px;">
          <input id="has-steel-checkbox" type="checkbox" onchange="onHasSteelPlatesChange()"> 
          Add steel plates (Flitch Beam)
        </label> 
        <div id="steel-plate-div" class="d-none" style="padding:10px;">
          <table>
            <tr>
              <td style="padding:10px;">Plate Thickness, <em>t</em> (inches)</td>
              <td><input type="text" class="form-control" style="width:100px;" id="plate-thickness" onchange="onFlitchBeamPropertiesChange()" value="0.375"></td>
            </tr>
            <tr>
              <td style="padding:10px;">Plate Height, <em>h</em> (inches)</td>
              <td><input type="text" class="form-control" style="width:100px;" id="plate-height" onchange="onFlitchBeamPropertiesChange()" value="7.25"></td>
            </tr>
            <tr>
              <td style="padding:10px;">Number of Plates</td>
              <td>
                <select id="number-plates-selector" class="form-control" onchange="onFlitchBeamPropertiesChange()">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    `

    document.getElementById('lumber-shape').onclick = (() => this.onShapeFileClick('lumber-shape'))
    document.getElementById('trus-joist-shape').onclick = (() => this.onShapeFileClick('trus-joist-shape'))
    document.getElementById('other-vendors-east-joist-shape').onclick = (() => this.onShapeFileClick('other-vendors-east-joist-shape'))
    document.getElementById('other-vendors-west-joist-shape').onclick = (() => this.onShapeFileClick('other-vendors-west-joist-shape'))
    
    this.onShapeFileClick('lumber-shape')
  }
}

customElements.define('wood-shape-selector-component', WoodShapesComponent)

function onHasSteelPlatesChange() {
  console.log('change steel plates')
  if(customerGate()) { 
    $('#modal-shape-selector-dialog').modal('hide');
    const checkbox = document.getElementById('has-steel-checkbox')
    checkbox.checked = false
    return; 
  }
  const checkbox = document.getElementById('has-steel-checkbox')
  const div = document.getElementById("steel-plate-div")
  checkbox.checked ? div.classList.remove('d-none') : div.classList.add('d-none')
  if(checkbox.checked) {
    onFlitchBeamPropertiesChange()
  } else {
    const customEvent = new CustomEvent('flitch-updated')
    document.dispatchEvent(customEvent)
  }
}

function onFlitchBeamPropertiesChange() {
  if(validateRequiredInput("plate-thickness") && validateLengthInput("plate-thickness")) {
    const flitch = {
      plateThickness: wsParseLength(document.getElementById('plate-thickness').value, "inches"),
      plateHeight: wsParseLength(document.getElementById('plate-height').value, "inches"),
      numberOfPlates: parseInt(document.getElementById('number-plates-selector').value)
    }
    const customEvent = new CustomEvent('flitch-updated', { detail: flitch })
    document.dispatchEvent(customEvent)
  } 
}

function configureFlitchBeamForm(beamProject) {
  let checkbox = document.getElementById('has-steel-checkbox')
  checkbox.checked = true
  document.getElementById("steel-plate-div").classList.remove('d-none')
  document.getElementById('plate-thickness').innerHTML = beamProject.shape.flitch.plateThickness
  document.getElementById('plate-height').innerHTML = beamProject.shape.flitch.plateHeight
  document.getElementById('number-plates-selector').value = beamProject.shape.flitch.numberOfPlates
}